import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createExaCustomer, updateExaCustomer, deleteExaCustomer, getExaCustomer, getExaCustomerList } from '@/api/customer';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
export default {
  name: 'Customer',
  filters: {
    formatDate: function formatDate(time) {
      if (time !== null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getExaCustomerList,
      dialogFormVisible: false,
      type: '',
      form: {
        customerName: '',
        customerPhoneData: ''
      }
    };
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    updateCustomer: function updateCustomer(row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getExaCustomer({
                ID: row.ID
              });
            case 1:
              res = _context.sent;
              _this.type = 'update';
              if (res.code === 0) {
                _this.form = res.data.customer;
                _this.dialogFormVisible = true;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.form = {
        customerName: '',
        customerPhoneData: ''
      };
    },
    deleteCustomer: function deleteCustomer(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              row.visible = false;
              _context2.next = 1;
              return deleteExaCustomer({
                ID: row.ID
              });
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  type: 'success',
                  message: ''
                });
                if (_this2.tableData.length === 1 && _this2.page > 1) {
                  _this2.page--;
                }
                _this2.getTableData();
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _t = _this3.type;
              _context3.next = _t === 'create' ? 1 : _t === 'update' ? 3 : 5;
              break;
            case 1:
              _context3.next = 2;
              return createExaCustomer(_this3.form);
            case 2:
              res = _context3.sent;
              return _context3.abrupt("continue", 7);
            case 3:
              _context3.next = 4;
              return updateExaCustomer(_this3.form);
            case 4:
              res = _context3.sent;
              return _context3.abrupt("continue", 7);
            case 5:
              _context3.next = 6;
              return createExaCustomer(_this3.form);
            case 6:
              res = _context3.sent;
              return _context3.abrupt("continue", 7);
            case 7:
              if (res.code === 0) {
                _this3.closeDialog();
                _this3.getTableData();
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openDialog: function openDialog() {
      this.type = 'create';
      this.dialogFormVisible = true;
    }
  }
};